import { Numeric }			from "@v3/data/numeric";
import { NaturalNumber }	from "@v3/data/primitive";

// minute of hour between 0 and 59
export type Minute	= Numeric.Value<typeof Minute>;
export const Minute	= NaturalNumber.constrain("Minute", 0, 59);
